var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{attrs:{"value":_vm.value,"state":_vm.valid,"placeholder":_vm.placeholder},on:{"input":function($event){_vm.$emit('input', _vm.returnValue())}},model:{value:(_vm.rawInput),callback:function ($$v) {_vm.rawInput=$$v},expression:"rawInput"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ff55c9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ucrdrk-input-number.vue
// module id = 335
// module chunks = 1